// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__28Gby","title":"ClientReferral_title__2TQF1","itemText":"ClientReferral_itemText__xwv_p"};